let current = 1000;

/** Shared z-index counter so the most recently focused floating window stacks on top. */
export function nextZIndex(): number {
  current += 1;
  return current;
}

/** Current top of the counter, without incrementing it — lets a window check whether it's
 * already the frontmost one before bumping the shared counter again. */
export function peekZIndex(): number {
  return current;
}

/** §8.5: a dialog that can open from inside an antd `modal.confirm`'s `onOk` (e.g. the preview
 * dialog for «Отменить»/«Удалить») cannot just take the next `nextZIndex()` value — antd manages
 * `modal.confirm`'s own z-index automatically and independently of this counter, and it can end up
 * *higher* than any FloatingWindow currently open (observed 2000 for one level of nesting, vs. this
 * counter sitting around 1000+N). Reads the current highest z-index actually in the DOM (any open
 * FloatingWindow or antd Modal/confirm) and returns comfortably above it, so the nested dialog is
 * guaranteed to render on top regardless of which system opened first. */
export function aboveEverythingZIndex(): number {
  let max = current;
  if (typeof document !== 'undefined') {
    for (const el of document.querySelectorAll<HTMLElement>('.ant-modal-wrap, .ant-modal-mask')) {
      const z = parseInt(getComputedStyle(el).zIndex, 10);
      if (!Number.isNaN(z) && z > max) max = z;
    }
  }
  return max + 10;
}
